import script from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./EcoPopup.vue?vue&type=style&index=0&id=ec865a68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec865a68"]])

export default __exports__